import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { MeetingEmbedAppraisal } from '../../../../../types'
import PerFlexRow from '../../../../../components/custom_components/FlexRow'
import PerText from '../../../../../components/custom_components/Text'
import { MeetingModal } from './MeetingModal'
import { LabeledCheckbox } from './LabeledCheckbox'

export type EmployeeMeetingModalAppraisal = Pick<MeetingEmbedAppraisal, 'selfReflectionShared' | 'evaluationShared'>

interface MeetingModalEmployeeProps {
  appraisal: EmployeeMeetingModalAppraisal
  visible: boolean
  onCancel: () => void
  onConfirm: (selfReflectionShared: boolean, evaluationShared: boolean) => void
  hasSelfreflection: boolean
  hasEvaluation: boolean
}

const MeetingModalEmployeePreparation: FC<MeetingModalEmployeeProps> = ({
  onCancel,
  onConfirm,
  visible,
  appraisal,
  hasEvaluation,
  hasSelfreflection,
}) => {
  const [t] = useTranslation()

  const [selfReflectionShared, setSelfReflectionShared] = useState(appraisal.evaluationShared)
  const [evaluationShared, setEvaluationShared] = useState(appraisal.evaluationShared)

  const handleConfirm = () => {
    onConfirm(selfReflectionShared, evaluationShared)
  }
  return (
    <MeetingModal title={t('appraisalMeeting.stepFeedback.modal.header')} visible={visible} onCancel={onCancel} onConfirm={handleConfirm}>
      {(hasEvaluation || hasSelfreflection) && (
        <>
          <PerText fontWeight="bold">{t('appraisalMeeting.stepFeedback.modal.message1')}</PerText>
          <PerFlexRow direction="column" mr="l" my="m">
            {hasSelfreflection && (
              <div data-e2e-share-selfreflection-checkbox>
                <LabeledCheckbox
                  name="selfReflectionShared"
                  checked={selfReflectionShared}
                  onChange={() => {
                    setSelfReflectionShared(!selfReflectionShared)
                  }}
                  label={t('appraisalMeeting.stepFeedback.modal.share.selfReflection')}
                />
              </div>
            )}

            {hasEvaluation && (
              <LabeledCheckbox
                data-e2e-evaluation-shared-checkbox
                name="evaluationShared"
                checked={evaluationShared}
                onChange={() => {
                  setEvaluationShared(!evaluationShared)
                }}
                label={t('appraisalMeeting.stepFeedback.modal.share.evaluation')}
              />
            )}
          </PerFlexRow>
        </>
      )}

      {t('appraisalMeeting.stepFeedback.modal.share.combined')}
      <PerText fontWeight="bold" mt="m" mb="s">
        {t('appraisalMeeting.stepConclusion.modal.reviewer.header')}
      </PerText>
    </MeetingModal>
  )
}
export { MeetingModalEmployeePreparation }
